// ./src/pages/public/ForgotPasswordPage/ForgotPasswordPage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthLayout } from "@/components/layouts/AuthLayout";
import { ForgotPasswordForm } from "@/components/features/Authentication/ForgotPasswordForm";
import { PageProps } from "@sdflc/react-router-pages";

// Props that @sdflc/react-router-pages passes to page components
export interface ForgotPasswordPageProps extends PageProps {}

export const ForgotPasswordPage: React.FC<ForgotPasswordPageProps> = () => {
  const navigate = useNavigate();

  const handleResetRequestSuccess = () => {
    console.log("Password reset link sent successfully");

    // Optionally navigate back to signin after a delay
    // The form already shows success message for 3 seconds
    setTimeout(() => {
      navigate("/account/signin");
    }, 3000);
  };

  const handleNavigateToSignin = () => {
    navigate("/account/signin");
  };

  return (
    <AuthLayout
      title="Forgot Password"
      subtitle="Reset your FormSubmits password"
    >
      <ForgotPasswordForm
        onResetRequestSuccess={handleResetRequestSuccess}
        onNavigateToSignin={handleNavigateToSignin}
      />
    </AuthLayout>
  );
};
